// extracted by mini-css-extract-plugin
export var leftAlign = "_2a-2";
export var popper = "_2a-0";
export var subtitle = "_2a-1";